module.exports = __webpack_public_path__ + "img/logo-white.8495cc82.png";